const CONSENT_KEY = 'bienlivrer_cookie_consent';
const SESSION_KEY = 'bienlivrer_session_id';

const API_BASE = import.meta.env.VITE_API_URL
  ? `${import.meta.env.VITE_API_URL}/api/v1`
  : '/api/v1';

function hasAnalyticsConsent(): boolean {
  try {
    return localStorage.getItem(CONSENT_KEY) === 'accepted';
  } catch {
    return false;
  }
}

export function getOrCreateSessionId(): string {
  try {
    const existing = localStorage.getItem(SESSION_KEY);
    if (existing && existing.length >= 8) return existing;
    const id = crypto.randomUUID();
    localStorage.setItem(SESSION_KEY, id);
    return id;
  } catch {
    return crypto.randomUUID();
  }
}

type AnalyticsEventName = 'page_view' | 'shop_view' | 'product_view' | 'checkout_start';

export function trackEvent(eventName: AnalyticsEventName, properties?: Record<string, unknown>): void {
  if (!hasAnalyticsConsent()) return;

  const sessionId = getOrCreateSessionId();
  const body = JSON.stringify({ eventName, sessionId, properties });

  fetch(`${API_BASE}/analytics/events`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true,
  }).catch(() => undefined);
}

export function trackPageView(path: string): void {
  trackEvent('page_view', { path });
}

export function initAnalyticsIfConsented(): void {
  if (hasAnalyticsConsent()) {
    trackPageView(window.location.pathname);
  }
}
